import { render, staticRenderFns } from "./NewToupiao.vue?vue&type=template&id=1ddb6248&scoped=true"
import script from "./NewToupiao.vue?vue&type=script&lang=js"
export * from "./NewToupiao.vue?vue&type=script&lang=js"
import style0 from "./NewToupiao.vue?vue&type=style&index=0&id=1ddb6248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb6248",
  null
  
)

export default component.exports